import Api from "~/service/Api";

class MlsServiceLogRepository {
  fetch(query = {}) {
    return Api.get("/mls-service/logs", query);
  }

  fetchOne(mlsServiceLogId) {
    return Api.get(`/mls-service/logs/${mlsServiceLogId}`);
  }
}

export default MlsServiceLogRepository;
